import services from './_services'

export default {
  getActivityIndex (params) {
    return services.getWithParams(process.env.ROOT_API + '/activity', params)
  },
  getActivity (id) {
    return services.get(process.env.ROOT_API + '/activity/' + id)
  },
  getExportOfActivities (searchQuery) {
    return services.enqueueCall(process.env.ROOT_API + '/activity/export', searchQuery)
  },
  getPrintableActivityIndex () {
    return services.get(process.env.ROOT_API + '/activity/printable')
  },
  getOnBehalfOfUsers () {
    return services.get(process.env.ROOT_API + '/activity/users')
  },
  updateActivityCategory (id, json) {
    return services.put(process.env.ROOT_API + '/activity/' + id + '/category', json)
  },
  updateActivityAuthor (id, authorID) {
    return services.put(process.env.ROOT_API + '/activity/' + id + '/user/' + authorID, {})
  },
  addReminder (id, json) {
    return services.post(process.env.ROOT_API + '/activity/' + id + '/reminder', json)
  },
  addAccountToActivity (activityID, accountID) {
    return services.post(process.env.ROOT_API + '/activity/' + activityID + '/user/' + accountID, {})
  },
  getActivitiesByYearAndWeek (year, week) {
    return services.get(process.env.ROOT_API + '/activity/year/' + year + '/week/' + week)
  },
  createActivity (activityObject) {
    return services.post(process.env.ROOT_API + '/activity', activityObject)
  }
}



// WEBPACK FOOTER //
// ./src/api/activity.js